import { Container, Button } from "react-bootstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import MaterialTable from "material-table";
import _ from "lodash";
import { TruncatedText } from "../../../components/truncateText";
import { GlobalSpinner } from "../../../../../global/globalFunctions";


const styles = {
    card: {
        border: "1px solid #ddd",
        borderRadius: "12px",
        padding: "10px",
        textAlign: "center",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        backgroundColor: "#81ABD3",
    },
    container: {
        display: "flex",
        gap: "15px",
        margin: "10px",
    },
    heading: {
        fontSize: "15px",
        fontWeight: "bold",
        marginBottom: "10px",
    },
    data: {
        fontSize: "13px",
        fontWeight: "600",
        color: "#333",
    },
};
const LedgerSearchDetails = ({ searchAccountLedger, isFetchingAccountLedger }) => {
    if (isFetchingAccountLedger) {
        return (
            <GlobalSpinner />
        )
    }

    const ledgerCards = [
        { title: "Account Name", data: `${searchAccountLedger.levelFourKey} - ${searchAccountLedger.levelFourName}` || "" },
        { title: "Opening Balance", data: `${searchAccountLedger.data?.[0]?.closingBalance.toLocaleString()}/-` || 0 },
        { title: "Total Debit", data: `${searchAccountLedger?.debitSum?.toLocaleString()}/-` || 0 },
        { title: "Total Credit", data: `${searchAccountLedger?.creditSum?.toLocaleString()}/-` || 0 },
        { title: "Closing Balance", data: `${searchAccountLedger?.closingBalance?.toLocaleString()}/-` || 0 },
        { title: "From - To", data: `${searchAccountLedger.startDate} - ${searchAccountLedger.endDate}` || "" },
    ];

    return (
        <Container fluid>
            <div className="sendDiv" style={{ marginTop: '-10px' }}>
                <Link to="/accountsModule/Ledger">
                    <Button><b>BACK TO SEARCH</b></Button>
                </Link>
            </div>

            <div style={styles.container}>
                {ledgerCards.map((card, index) => (
                    <div key={index} style={styles.card}>
                        <div style={styles.heading}>{card.title}</div>
                        <div style={styles.data}>{card.data}</div>
                    </div>
                ))}
            </div>

            <MaterialTable
                columns={[
                    { title: 'Date', field: 'voucherDate', },
                    { title: "Voucher ID", field: "vocManualNumber", },
                    {
                        title: "Description", field: "voucherDescription",
                        render: rowData => <TruncatedText text={rowData.voucherDescription} maxLength={20} />
                    },
                    { title: "Bill No", field: "billNumber" },
                    { title: "Cheque No", field: "chequeNo", },
                    { title: "Cheque Date", field: "chequeDate", },
                    { title: "Debit", field: "debit", render: rowData => !_.hasIn(rowData, 'debit') || _.isNull(rowData.debit) ? "" : `${rowData.debit.toLocaleString()}/-` },
                    { title: "Credit", field: "credit", render: rowData => !_.hasIn(rowData, 'credit') || _.isNull(rowData.credit) ? "" : `${rowData.credit.toLocaleString()}/-` },
                    { title: "Closing Balance", field: "closingBalance", render: rowData => `${rowData.closingBalance.toLocaleString()}/-`, },
                    { title: 'Type', field: 'closingBalanceSign' },
                    { title: "Created By", field: "userDetails" },
                ]}
                data={searchAccountLedger.data || []}
                options={{
                    exportButton: true,
                    toolbar: true,
                    showTitle: false,
                    actionsColumnIndex: -1,
                    paging: true,
                    pageSize: 50,
                    pageSizeOptions: [50, 100, 150, 200],
                    emptyRowsWhenPaging: false,
                    search: true,
                    headerStyle: {
                        position: "sticky",
                        top: 0,
                        color: "#00BBBB",
                        fontWeight: "550",
                        fontSize: "13px",
                        padding: "4px 8px",
                        // backgroundColor: "#f1f1f1",
                        borderBottom: "2px solid #ddd" // Add bottom border to header
                    },
                    cellStyle: {
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        fontSize: "13px",
                        padding: "6px 10px",
                        border: "1px solid #ddd" // Add border for grid effect
                    },
                    rowStyle: {
                        fontSize: "13px",
                        padding: "6px 10px",
                        lineHeight: "1",
                        borderBottom: "1px solid #ddd", // Add bottom border between rows
                        backgroundColor: "#fff" // Ensure background is white
                    }
                }}
            />
        </Container>
    );
};

const mapStateToProps = (state) => ({
    searchAccountLedger: state.AccountLegderReducer2.searchAccountLedger,
    isFetchingAccountLedger: state.AccountLegderReducer2.isFetchingAccountLedger,
});

export default connect(mapStateToProps)(LedgerSearchDetails);